import { render, staticRenderFns } from "./NotaryDetail.vue?vue&type=template&id=56dba070&"
import script from "./NotaryDetail.vue?vue&type=script&lang=ts&"
export * from "./NotaryDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports